import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { AvailableLanguage, getRequestedAvailableLanguages } from 'helpers';

@Component({
    selector: 'fc-contact-language',
    templateUrl: './contact-language.component.html',
    styleUrls: ['./contact-language.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContactLanguageComponent implements OnChanges {
    @Input() public contactLanguage = 'de';
    @Input() public disabled = false;
    @Output() public onLanguageChange = new EventEmitter<any>();

    public currentLanguage: Language = { name: 'Deutsch', flag: 'de' };
    public selectableLanguages: { key: string; name: string; flag: string }[];
    public dropdownDirection: string;

    private languages;

    constructor() {
        this.languages = getRequestedAvailableLanguages([
            AvailableLanguage.En,
            AvailableLanguage.De,
            AvailableLanguage.Nl
        ]);
        this.dropdownDirection = 'down';
        this.setSelectableLanguages();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (_.get(changes, 'contactLanguage.currentValue')) {
            this.currentLanguage = this.languages[this.contactLanguage];
        }
    }

    public selectLanguage(language) {
        this.onLanguageChange.emit(language);
        this.currentLanguage = this.languages[language.key];
    }

    private setSelectableLanguages() {
        const selectableLanguagesKeys = _.keys(this.languages);
        this.selectableLanguages = _.map(selectableLanguagesKeys, (language) => ({
            key: language,
            name: this.languages[language].name,
            flag: this.languages[language].flag
        }));
    }
}

interface Language {
    name: string;
    flag: string;
}
